import { useTranslation } from 'next-i18next'
import Link from 'next/link'
import React from 'react'

import ProfileSearch from './ProfileSearch'

export default function ProfileNotFound() {
  const { t: _t } = useTranslation('common')

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
      <div className="w-24 h-24 bg-red-500/10 rounded-full flex items-center justify-center mb-6">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-12 w-12 text-red-500"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
          />
        </svg>
      </div>
      <h1 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4">
        Perfil não encontrado
      </h1>
      <p className="text-white/60 max-w-md mb-8 text-lg">
        O perfil que você está procurando não existe ou foi removido. Verifique
        o link ou tente uma nova busca.
      </p>

      <div className="w-full max-w-xl mb-10">
        <ProfileSearch />
      </div>

      <Link
        href="/"
        className="px-8 py-4 bg-red-600 hover:bg-red-700 text-white font-bold rounded-xl transition-all hover:scale-105 shadow-lg shadow-red-600/20"
      >
        Voltar para o Início
      </Link>
    </div>
  )
}
